import React from 'react';
import { Tab, styled, Box } from '@mui/material';
import { TabContainerTabArgs } from 'components/nav/TabContainer';
import TabBadge from 'components/nav/TabBadge';
import history from 'services/history';
import { RiAddCircleLine } from 'react-icons/ri';

export interface TabContainerTabProps {
	index: number;
	active: boolean;
	tab: TabContainerTabArgs;
	basePath: string;
}
const TabContainerTab = (props: TabContainerTabProps) => {
	const { tab, index, basePath, active } = props;

	const getTabFullPath = (tab: TabContainerTabArgs) => {
		return `${basePath}/${tab.path}`;
	};

	const handleTabClick = () => {
		history.push(getTabFullPath(tab));
	};

	const label = (() => {
		if (!!tab.locked) {
			return (
				<Box
					sx={{
						display: 'inline-block',
						color: (theme) => theme.palette.text.primary,
						position: 'relative',
						paddingRight: (theme) => theme.spacing(2),
					}}
				>
					<Box sx={{ opacity: 0.33 }}>{tab.label}</Box>
					<Box
						sx={{
							position: 'absolute',
							right: 0,
							top: -5,
							color: (theme) => theme.palette.success.main,
						}}
					>
						<RiAddCircleLine size={16} />
					</Box>
				</Box>
			);
		}

		if (!!tab.badge) {
			return (
				<span>
					{tab.label} <TabBadge text={tab.badge} />
				</span>
			);
		}

		return tab.label;
	})();

	return (
		<StyledTab
			key={tab.path}
			label={label}
			value={index}
			disabled={tab.disabled}
			onClick={handleTabClick}
			/**
			 * This hack is needed, since MUI Tabs does not properly detect which child is active
			 * if using a separate component instace for custom tabs like we have here
			 */
			data-active={active}
		/>
	);
};

const StyledTab = styled(Tab)(({ theme }) => ({
	textTransform: 'none',
	fontSize: '1.6rem',
	color: theme.palette.text.primary,
	opacity: 1,
	'& > *': {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	'&[data-active="true"]': {
		color: theme.palette.primary.main,
	},
}));

export default TabContainerTab;
